import { Navigate, Route, Routes } from 'react-router-dom';

import { NotFound } from 'common/components';
import { MASTER_ROUTES } from './routes';
import Source from './components/Source';
import AgentLayout from 'features/agent/components/AgentLayout';
import { AGENT_ROUTES } from 'features/agent/routes';
import {
  AddLoanTypePayload,
  AddSourcePayload,
  SourcePayload,
  updateSourcePayload,
  UserFilter,
  FundAccountUpdatePayload,
} from 'api/master';
import AddSource from './components/AddSource';
import LoanType from './components/LoanType';
import AddLoanType from './components/AddLoanType';
import User from './components/User';
import UpdateSource from './components/UpdateSource';

//Masters Migeration code 

import FundAccount from './features/fundaccount/components/Filter';
import DedupeConfig from './features/dedupeconfig/components/Filter';
import ApplevelConfig from './features/applevelconfig/Filter';
import ServiceMapping from './features/servicemapping/components/Filter';
import CallbackConfig from './features/callbackconfig/components/Filter';
import UpdateFunAccount from './features/updatefundaccount';
import Addfundaccount from './features/addfundaccount';

const MasterContainer = () => (
  <Routes>
    <Route element={<AgentLayout />}>
      <Route index element={<Navigate replace to={AGENT_ROUTES.dashboard.to} />} />
      {/* <Route index element={<Navigate replace to={MASTER_ROUTES.index.to} />} /> */}
      <Route
        path={MASTER_ROUTES.source.path}
        element={
          <Source
            isLoading={false}
            onSubmit={function (_values: SourcePayload): Promise<void> {
              throw new Error('Function not implemented.');
            }}
          />
        }
      />
      <Route
        path={MASTER_ROUTES.addSource.path}
        element={
          <AddSource
            isAdmin={false}
            onSubmit={function (_values: AddSourcePayload): Promise<void> {
              throw new Error('Function not implemented.');
            }}
          />
        }
      ></Route>
      <Route
        path={MASTER_ROUTES.updateSource.path}
        element={
          <UpdateSource
            isAdmin={false}
            onSubmit={function (_values: updateSourcePayload): Promise<void> {
              throw new Error('Function not implemented.');
            }}
          />
        }
      ></Route>

      <Route
        path={MASTER_ROUTES.loanType.path}
        element={
          <LoanType
            isLoading={false}
            onSubmit={function (_values: SourcePayload): Promise<void> {
              throw new Error('Function not implemented.');
            }}
          />
        }
      />
      <Route
        path={MASTER_ROUTES.addLoanType.path}
        element={
          <AddLoanType
            isAdmin={false}
            onSubmit={function (_values: AddLoanTypePayload): Promise<void> {
              throw new Error('Function not implemented.');
            }}
          />
        }
      />
      <Route
        path={MASTER_ROUTES.user.path}
        element={
          <User
            onSubmit={function (_values: UserFilter): Promise<void> {
              throw new Error('Function not implemented.');
            }}
            isLoading={false}
          />
        }
      />
      <Route path={MASTER_ROUTES.fundAccount.path} element={<FundAccount />} />
      <Route path={MASTER_ROUTES.dedupe.path} element={<DedupeConfig />} />
      <Route path={MASTER_ROUTES.applevelConfig.path} element={<ApplevelConfig />} />
      <Route path={MASTER_ROUTES.serviceMappConfig.path} element={<ServiceMapping />} />
      <Route path={MASTER_ROUTES.callbackConfig.path} element={<CallbackConfig />} />
      <Route
        path={MASTER_ROUTES.updatefundaccountSource.path}
        element={
          <UpdateFunAccount
            isAdmin={false}
            onSubmit={function (_values: FundAccountUpdatePayload): Promise<void> {
              throw new Error('Function not implemented.');
            }}
          />
        }
      />

      {/* <Route
        path={MASTER_ROUTES.updatefundaccountSource.path}
        element={
          <UpdateSource
            isAdmin={true}
            onSubmit={function (_values: FundAccountUpdatePayload): Promise<void> {
              throw new Error('Function not implemented.');
            }}
          />
        }
      /> */}

      <Route
        path={MASTER_ROUTES.addfundaccount.path}
        element={
          <Addfundaccount
            isAdmin={true}
            onSubmit={function (_values: FundAccountUpdatePayload): Promise<void> {
              throw new Error('Function not implemented.');
            }}
          />
        }
      />

      <Route path="*" element={<NotFound />} />
    </Route>
  </Routes>
);

export default MasterContainer;
